import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';
import { Resources } from '../../resource';

const REWARD_FEED_LIST_RESOURCES = new Set<string>([Resources.blindBoxRewardFeed]);

function normalizeRewardFeedBody(filter: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = { ...filter };
  const dropEmpty = (k: string) => {
    const v = out[k];
    if (v === '' || v === undefined) delete out[k];
  };
  ['userId', 'walletAddress', 'winStatus', 'rewardCategory', 'seasonId', 'issueNumber', 'taskSlug', 'from', 'to'].forEach(
    dropEmpty
  );
  const issueRaw = out.issueId;
  if (issueRaw === '' || issueRaw === undefined) {
    delete out.issueId;
  } else {
    const n = parseInt(String(issueRaw), 10);
    if (Number.isFinite(n)) out.issueId = n;
    else delete out.issueId;
  }
  if (out.sortAsc !== true) delete out.sortAsc;
  return out;
}

class RewardFeedDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (!REWARD_FEED_LIST_RESOURCES.has(resource)) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {} } = params;

    const body = normalizeRewardFeedBody(filter as Record<string, unknown>);
    body.limit = perPage;
    body.offset = (page - 1) * perPage;

    const url = `${baseUrl}/blind-box/reward-feed`;
    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    const entries = json?.entries ?? [];
    const total = json?.total ?? 0;
    return { data: entries, total };
  }
}

export const dataProvider = new RewardFeedDataProvider();

// auto init
registerModuleDataProvider(Resources.blindBoxRewardFeed, dataProvider);

